// Zentrale Terminbuchung (Microsoft Bookings) - alle "Termin/Kurs buchen"-Buttons verlinken hierher
export const BOOKING_URL =
  'https://bookings.cloud.microsoft/book/PositivFitnessWolnzach@positivwolnzach.onmicrosoft.com/?ismsaljsauthenabled=true';
